import { render, staticRenderFns } from "./downloadInfo.vue?vue&type=template&id=079ccb66"
import script from "./downloadInfo.vue?vue&type=script&lang=js"
export * from "./downloadInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports